import {useEffect} from 'react';
import {useGetPollInfo} from './useGetPollList';

export const PollListDetails = () => {
  const {
    downloadingPollInfoErrorMsg,
    downloadingPollInfoStatus,
    getPollInfo,
    pollList,
  } = useGetPollInfo({mode: 'pollList'});

  useEffect(() => {
    getPollInfo();
  }, [getPollInfo]);

  if (downloadingPollInfoStatus === 'requesting') {
    return <span className="loading loading-spinner loading-sm p-5" />;
  }
  if (downloadingPollInfoStatus === 'error') {
    return (
      <div className="p-5">
        <p className="text-red-600">Error:</p>
        <p>{downloadingPollInfoErrorMsg}</p>
      </div>
    );
  }
  return (
    <div className="p-5">
      <h1 className="text-5xl text-center font-semibold">Poll List</h1>

      <ul className="pt-5">
        {pollList &&
          pollList.map((poll, i) => {
            return (
              <li key={poll.pollId}>
                <div className="flex gap-3 pt-2" key={poll.pollId}>
                  <a
                    href={`/polls/${poll.pollId}`}
                    key={poll.pollId}
                    className="flex gap-3">
                    <p>🗳️</p>
                    <h2 className="font-bold underline">{poll.pollId}</h2>
                  </a>
                  <p>
                    <b className="font-semibold">Response Count: </b>
                    {poll.responseCount},
                  </p>
                  <p>
                    {' '}
                    <b className="font-semibold">First Reponse:</b>{' '}
                    {poll.firstResponseTimestamp}
                  </p>
                </div>
              </li>
            );
          })}
      </ul>
    </div>
  );
};
